import React from "react";
import { CONTACT, SOCIAL } from "@/config";
import { KeyRound, Globe, BarChart3, MessageCircle } from "lucide-react";

const Card = ({ icon: Icon, title, children, testid }) => (
  <div data-testid={testid} className="bg-[#0C1310] border border-[#1E2B25] p-6">
    <div className="flex items-center gap-3 mb-4">
      <Icon size={16} className="text-[#C4A661]" strokeWidth={1.5} />
      <h2 className="font-serif-hc text-xl text-[#F5F2EA]">{title}</h2>
    </div>
    <div className="text-sm text-[#A3A095] leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function AdminSettings() {
  return (
    <div data-testid="admin-settings">
      <p className="eyebrow mb-2">Sistema</p>
      <h1 className="font-serif-hc font-light text-3xl md:text-4xl text-[#F5F2EA]">Configuración</h1>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-4xl">
        <Card icon={KeyRound} title="Acceso del equipo" testid="settings-access">
          <p>El panel está protegido con una clave compartida que se solicita al entrar.</p>
          <p>Para cambiarla, solicita la actualización de la variable <span className="text-[#F5F2EA]">ADMIN_ACCESS_KEY</span> y comparte la nueva clave solo con el equipo autorizado.</p>
        </Card>
        <Card icon={MessageCircle} title="Contacto del sitio" testid="settings-contact">
          <p>WhatsApp: <span className="text-[#F5F2EA]">{CONTACT.WHATSAPP_DISPLAY}</span></p>
          <p>Email: <span className="text-[#F5F2EA]">{CONTACT.EMAIL}</span></p>
          <p className="text-xs">Estos datos aparecen en el sitio público. Si aún son placeholders, envía los reales para actualizarlos.</p>
        </Card>
        <Card icon={BarChart3} title="Analytics" testid="settings-analytics">
          <p>Google Analytics 4 y Meta Pixel están instalados pero <span className="text-[#C4A661]">inactivos</span>.</p>
          <p className="text-xs">Se activan al configurar los IDs (GA4 <span className="text-[#F5F2EA]">G-XXXXXXXXXX</span> y Pixel de ~15 dígitos).</p>
        </Card>
        <Card icon={Globe} title="Sitio público" testid="settings-site">
          <p>Idiomas: Español / Inglés (toggle en navbar).</p>
          <p>Redes: Instagram {SOCIAL.INSTAGRAM_URL === "#" ? "(pendiente)" : "✓"} · Facebook {SOCIAL.FACEBOOK_URL === "#" ? "(pendiente)" : "✓"} · TikTok {SOCIAL.TIKTOK_URL === "#" ? "(pendiente)" : "✓"}</p>
        </Card>
      </div>
    </div>
  );
}
